import { render, staticRenderFns } from "./VCandidate.vue?vue&type=template&id=b7377358&scoped=true&lang=pug"
import script from "./VCandidate.vue?vue&type=script&lang=ts"
export * from "./VCandidate.vue?vue&type=script&lang=ts"
import style0 from "./VCandidate.vue?vue&type=style&index=0&id=b7377358&prod&lang=sass&scoped=true"
import style1 from "./VCandidate.vue?vue&type=style&index=1&id=b7377358&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7377358",
  null
  
)

export default component.exports